import { render, staticRenderFns } from "./TouchHandler.vue?vue&type=template&id=1c0c1b91&"
import script from "./TouchHandler.vue?vue&type=script&lang=js&"
export * from "./TouchHandler.vue?vue&type=script&lang=js&"
import style0 from "./TouchHandler.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports